import styled from 'styled-components'

export const Container = styled.div`
  width: 100vw;
  height: 100%;
  position: relative;

  .slick-prev {
      position: absolute;
      top: 50%;
      left: 0px;
      z-index: 1;
  }
  .slick-next {
      position: absolute;
      top: 50%;
      right: 20px;
      z-index: 1;
  }
`

